import React, { useState } from "react";
import * as S from "./styled";
import PT from "prop-types";
import { useNotify } from "@/hooks/useNotify";
import StepsUI from "./StepsUI";
import RoleForm from "./Forms/Role";
import EmailForm from "./Forms/Email";
import PasswordForm from "./Forms/Password";
import pick from "lodash/pick";
import { AnimatedList } from "_c/Animated";
import { ProgressEmitter } from "_c/GlobalProgress/emitter";
import { connect } from "react-redux";
import { Selectors as RegisterSelectors } from "@/store/userRegister/selectors";
import { Selectors as LocaleSelectors } from "@/store/locale/selectors";
import { Actions as ModalActions } from "@/store/modals/slice";
import { Actions as RegisterActions } from "@/store/userRegister/slice";
import { Effects as RegisterEffects } from "@/store/userRegister/effects";
import FinalStepEmail from "./FinalStepEmail";
import FinalStepPhone from "./FinalStepPhone";

const Registration = (props) => {
  const { notifyError } = useNotify();
  const [submitting, setSubmitting] = useState(false);
  const partialFormSubmitHandler = (form) => {
    props.updateForm(form);
    props.nextStep();
  };
  const finalPartialFormSubmitHandler = async (form) => {
    props.updateForm(form);
    try {
      setSubmitting(true);
      ProgressEmitter.start();
      await props.register();
    } catch (e) {
      console.error(e);
      notifyError(props.t([`errors:${e}`, "errors:unspecified_server"]));
      setSubmitting(false);
    } finally {
      ProgressEmitter.end();
    }
  };
  const finalStep = props.stepsAmount + 1;
  return (
    <S.Wrap>
      <StepsUI
        stepsAmount={props.stepsAmount}
        currentStep={props.step}
        completedSteps={props.completedSteps}
      />
      <S.FormsContainer>
        <AnimatedList.Container>
          {props.step === 1 && (
            <AnimatedList.Item itemKey={1}>
              <RoleForm
                isRoleSelected={props.isRoleSelected}
                updateForm={props.updateForm}
                nextStep={props.nextStep}
                t={props.t}
                form={props.form}
              />
            </AnimatedList.Item>
          )}

          {props.step === 2 && (
            <AnimatedList.Item itemKey={2}>
              <EmailForm
                strategy={props.strategy}
                changeStrategy={props.changeStrategy}
                prevStep={props.prevStep}
                locale={props.locale}
                isMaster={props.form.is_master}
                isSaloonOwner={props.form.is_saloon_owner}
                isClient={props.form.is_client}
                onSubmit={partialFormSubmitHandler}
                t={props.t}
                isUserAgreementAccepted={props.form.is_user_agreement_accepted}
                defaultValues={pick(props.form, [
                  "first_name",
                  "email",
                  "phone",
                ])}
              />
            </AnimatedList.Item>
          )}
          {props.step === 3 && (
            <AnimatedList.Item itemKey={3}>
              <PasswordForm
                prevStep={props.prevStep}
                onSubmit={finalPartialFormSubmitHandler}
                t={props.t}
                submitting={submitting}
                defaultValues={pick(props.form, [
                  "password",
                  "repeat_password",
                ])}
              />
            </AnimatedList.Item>
          )}
          {props.step === finalStep && (
            <AnimatedList.Item itemKey={finalStep}>
              <>
                {props.strategy === "email" && (
                  <FinalStepEmail
                    email={props.form.email}
                    t={props.t}
                    onClose={props.close}
                  />
                )}
                {props.strategy === "phone" && (
                  <FinalStepPhone
                    requestPhoneVerificationCode={
                      props.requestPhoneVerificationCode
                    }
                    submitPhoneVerificationCode={
                      props.submitPhoneVerificationCode
                    }
                    t={props.t}
                    phone={props.form.phone}
                    locale={props.locale}
                    isMaster={props.form.is_master}
                    isSaloonOwner={props.form.is_saloon_owner}
                    isClient={props.form.is_client}
                  />
                )}
              </>
            </AnimatedList.Item>
          )}
        </AnimatedList.Container>
      </S.FormsContainer>
    </S.Wrap>
  );
};
Registration.propTypes = {
  step: PT.number.isRequired,
  form: PT.object.isRequired,
  locale: PT.string.isRequired,
  completedSteps: PT.arrayOf(PT.number).isRequired,
  stepsAmount: PT.number.isRequired,
  strategy: PT.string.isRequired,
  isRoleSelected: PT.bool,

  t: PT.func.isRequired,
  changeStrategy: PT.func.isRequired,
  close: PT.func.isRequired,
  updateForm: PT.func.isRequired,
  nextStep: PT.func.isRequired,
  register: PT.func.isRequired,
  prevStep: PT.func.isRequired,
  requestPhoneVerificationCode: PT.func.isRequired,
  submitPhoneVerificationCode: PT.func.isRequired,
};
export default connect(
  (state) => ({
    strategy: RegisterSelectors.getStrategy(state),
    step: RegisterSelectors.getStep(state),
    form: RegisterSelectors.getForm(state),
    stepsAmount: RegisterSelectors.getStepsAmount(state),
    locale: LocaleSelectors.getLocale(state),
    completedSteps: RegisterSelectors.getCompletedSteps(state),
    isRoleSelected: RegisterSelectors.isRoleSelected(state),
  }),
  {
    changeStrategy: RegisterActions.changeStrategy,
    updateForm: RegisterActions.updateForm,
    nextStep: RegisterActions.nextStep,
    prevStep: RegisterActions.prevStep,
    register: RegisterEffects.register,
    close: ModalActions.closeAuth,
    requestPhoneVerificationCode: RegisterEffects.requestPhoneVerificationCode,
    submitPhoneVerificationCode: RegisterEffects.submitPhoneVerificationCode,
  },
)(Registration);
